export function Breadcrumb({ items = [], className = "" }) {
  return (
    <nav
      className={className}
      style={{
        overflowX: "auto",
        whiteSpace: "nowrap",
      }}
    >
      <ol
        className="breadcrumb mb-0"
        style={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "4px",
          minWidth: "max-content", // 🔥 important for scroll
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isClickable = !!item?.link;

          if(!item) return null;

          return (
            <li
              key={index}
              className={`breadcrumb-item ${
                isLast ? "active fw-semibold text-dark" : ""
              }`}
              {...(isLast && { "aria-current": "page" })}
              style={{ flexShrink: 0 }} // 🔥 prevents shrinking
            >
              {isClickable && !isLast ? (
                <a
                  href={item?.link}
                  className="text-decoration-none text-secondary"
                >
                  {item.label}
                </a>
              ) : (
                <span
                  className={`${
                    isClickable ? "text-secondary" : "text-muted"
                  } ${!isClickable && !isLast ? "opacity-75" : ""}`}
                  style={{
                    cursor: isClickable ? "pointer" : "not-allowed",
                  }}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}